<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-button v-on:click="goBack" variant="secondary">
          <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
        </b-button>
      </b-col>
    </b-row>
    <div class="addMode">
      <b-row>
        <b-col cols="12">
          <h1 v-if="addMode">Add Model</h1>
          <h1 v-if="editMode">Edit Model</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>Model Details</strong>
            </div>
            <div class="form-container">
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="modelName">
                      Name
                      <span class="mandatory">*</span>
                    </label>
                    <b-form-input v-model="newModel.model_name" type="text" id="modelName"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="modelManufacturer">
                      Manufacturer
                      <span class="mandatory">*</span>
                    </label>
                    <b-form-input
                      v-model="newModel.manufacturer"
                      type="text"
                      id="modelManufacturer"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="12" sm="12" md="12">
                  <p>
                    <b-button v-on:click="saveModel" variant="primary" :disabled="!allowSave">
                      <i class="fa fa-check"></i>&nbsp;Save Model
                    </b-button>
                  </p>
                  <b-alert v-if="saveError" variant="danger" show>
                    <strong>Error saving data. Please try again.</strong>
                  </b-alert>
                  <b-alert v-if="saveInProgress" variant="info" show>
                    <strong>Saving data. Please wait...</strong>
                  </b-alert>
                  <b-alert v-if="saveSuccess" variant="success" show>
                    <strong>Data saved successfully.</strong>
                  </b-alert>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "../../../components/loadingSpinner/LoadingSpinner";
import { usernameClean } from "../../../shared/utils";

const getHTTPHeaders = () => {
  let userObj = JSON.parse(localStorage.getItem("user"));
  return {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: userObj.token
    }
  };
};

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user != null) {
      resolve(user);
    } else {
      reject();
    }
  });
};

export default {
  name: "model-form",
  props: ["model", "mode"],
  components: {
    LoadingSpinner: LoadingSpinner
  },
  data() {
    return {
      userAuthLevel: "",
      addMode: false,
      editMode: false,
      saveError: false,
      saveInProgress: false,
      deleteSuccess: false,
      saveSuccess: false,
      show: true,
      newModel: this.model
    };
  },
  created() {
    this.$data.newModel = this.$props["model"];
    console.log(this.$data.newModel);
    this.$data.addMode = true;

    if (this.$props["mode"] === "edit") {
      this.$data.editMode = true;
      this.$data.addMode = false;
    }

    if (this.$props["mode"] === "add") {
      this.$data.addMode = true;
      this.$data.editMode = false;
      this.$data.newModel = this.resetModel();
    }

    // populate the dropdown controls
    getCurrentUser()
      .then(userDetails => {
        this.$data.userAuthLevel = userDetails.auth;
      })
      .catch(err => {
        console.error(err);
      });
  },
  computed: {
    isUserSuperAdmin() {
      if (this.$data.userAuthLevel == "Super Admin") {
        return true;
      } else {
        return false;
      }
    },
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case "Super Admin":
          returnVal = true;
          break;
        default:
          returnVal = false;
      }

      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case "Super Admin":
        case "Company Users":
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case "Super Admin":
        case "Company Users":
        case "Area Users":
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      console.log("Area: ", returnVal);
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case "Super Admin":
        case "Company Users":
        case "Area Users":
        case "Site Users":
          returnVal = true;
          break;
        default:
          returnVal = false;
      }

      return returnVal;
    },
    isUserReadOnly() {
      return this.isReadOnly(this.$data);
    },
    allowSave: function() {
      let allowSaveFlag = true;

      if (this.$data.newModel.model_name === "") {
        allowSaveFlag = false;
      }

      return allowSaveFlag;
    }
  },
  methods: {
    goBack: function() {
      this.$data.newModel = this.resetModel();
      this.$parent.closeModelForm();
    },
    isReadOnly(user) {
      return user.userAuthLevel === "Read Only";
    },
    resetModel() {
      return {
        id: 0,
        model_name: "",
        manufacturer: this.$data.newModel.manufacturer_name,
        manufacturer_id: this.$data.newModel.manufacturer_id
      };
    },
    getHTTPHeaders() {
      let user = JSON.parse(localStorage.getItem("user"));
      return {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization':  'Bearer ' + user.token,
        }
      };
    },
    clearAlerts() {
      this.$data.saveError = false;
      this.$data.saveInProgress = false;
    },
    saveModel() {
      this.clearAlerts();
      this.$data.saveInProgress = true;
      let headersObj = this.getHTTPHeaders();

      let url = "showplates/model";
      let method = "post";
      if (
        typeof this.$data.newModel.id !== undefined &&
        this.$data.newModel.id > 0
      ) {
        url += "/" + this.$data.newModel.id;
        method="put";
      }

      let dataPostObject = {
        model_name: this.$data.newModel.model_name,
        manufacturer_id: this.$data.newModel.manufacturer_id
      };

      this.$http[method](url, dataPostObject, headersObj)
        .then(response => {
          console.log(response.data);
          if (response.data.success == true) {
            this.$data.saveInProgress = false;
            this.$data.saveError = false;
            this.$data.saveSuccess = true;
            this.$parent.closeModelForm();
          } else {
            // data error
            this.$data.saveInProgress = false;
            this.$data.saveError = true;
          }
        })
        .catch(err => {
          console.error(err);
          this.$data.saveInProgress = false;
          this.$data.saveError = true;
        });
    }
  }
};
</script>